export default __webpack_public_path__ + "static/media/i-pessoas-autorizadas.97d039b7.png";